
import { useState } from 'react';

const QuoteForm = () => {
  const [formData, setFormData] = useState({
    nome: '',
    email: '',
    telefone: '',
    local: '',
    servico: '',
    observacoes: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus('idle');

    try {
      const formDataToSend = new FormData();
      Object.entries(formData).forEach(([key, value]) => {
        formDataToSend.append(key, value);
      });

      const response = await fetch(`${import.meta.env.VITE_PUBLIC_SUPABASE_URL}/functions/v1/submit-orcamento`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${import.meta.env.VITE_PUBLIC_SUPABASE_ANON_KEY}`,
        },
        body: formDataToSend
      });

      if (response.ok) {
        setSubmitStatus('success');
        setFormData({
          nome: '',
          email: '',
          telefone: '',
          local: '',
          servico: '',
          observacoes: ''
        });
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section id="orcamento" className="py-20 bg-[#111111]">
      <div className="max-w-4xl mx-auto px-6">
        <div className="text-center mb-12">
          <h3 className="text-3xl md:text-4xl font-bold mb-4">Solicite seu Orçamento</h3>
          <p className="text-[#C0C0C0] text-lg">
            Conte-nos sobre seu projeto e receba uma proposta personalizada
          </p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-6" data-readdy-form id="orcamento-form">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div>
              <label htmlFor="nome" className="block text-sm font-medium mb-2">
                Nome Completo *
              </label>
              <input
                type="text"
                id="nome"
                name="nome"
                value={formData.nome}
                onChange={handleChange}
                required
                className="w-full px-4 py-3 bg-[#2A2F2A] border border-[#A2AEAB]/30 text-white placeholder-[#A2AEAB] focus:border-[#C0C0C0] focus:outline-none transition-colors text-sm"
                placeholder="Seu nome completo"
              />
            </div>

            <div>
              <label htmlFor="email" className="block text-sm font-medium mb-2">
                E-mail *
              </label>
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
                className="w-full px-4 py-3 bg-[#2A2F2A] border border-[#A2AEAB]/30 text-white placeholder-[#A2AEAB] focus:border-[#C0C0C0] focus:outline-none transition-colors text-sm"
                placeholder="seu@email.com"
              />
            </div>

            <div>
              <label htmlFor="telefone" className="block text-sm font-medium mb-2">
                WhatsApp (com DDD) *
              </label>
              <input
                type="tel"
                id="telefone"
                name="telefone"
                value={formData.telefone}
                onChange={handleChange}
                required
                className="w-full px-4 py-3 bg-[#2A2F2A] border border-[#A2AEAB]/30 text-white placeholder-[#A2AEAB] focus:border-[#C0C0C0] focus:outline-none transition-colors text-sm"
                placeholder="(41) 99999-9999"
              />
            </div>

            <div>
              <label htmlFor="local" className="block text-sm font-medium mb-2">
                Local da Filmagem *
              </label>
              <input
                type="text"
                id="local"
                name="local"
                value={formData.local}
                onChange={handleChange}
                required
                className="w-full px-4 py-3 bg-[#2A2F2A] border border-[#A2AEAB]/30 text-white placeholder-[#A2AEAB] focus:border-[#C0C0C0] focus:outline-none transition-colors text-sm"
                placeholder="Cidade, bairro ou endereço"
              />
            </div>
          </div>

          <div>
            <label htmlFor="servico" className="block text-sm font-medium mb-2">
              Tipo de Serviço Desejado *
            </label>
            <div className="relative">
              <select
                id="servico"
                name="servico"
                value={formData.servico}
                onChange={handleChange}
                required
                className="w-full px-4 py-3 pr-8 bg-[#2A2F2A] border border-[#A2AEAB]/30 text-white focus:border-[#C0C0C0] focus:outline-none transition-colors text-sm appearance-none cursor-pointer"
              >
                <option value="">Selecione o tipo de serviço</option>
                <option value="institucional">Captação Aérea Institucional</option>
                <option value="obras">Filmagem de Obras e Terrenos</option>
                <option value="publicitario">Vídeos Publicitários e FPV</option>
                <option value="edicao-completa">Edição Completa</option>
                <option value="outro">Outro</option>
              </select>
              <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
                <i className="ri-arrow-down-s-line text-[#A2AEAB]"></i>
              </div>
            </div>
          </div>

          <div>
            <label htmlFor="observacoes" className="block text-sm font-medium mb-2">
              Observações Adicionais
            </label>
            <textarea
              id="observacoes"
              name="observacoes"
              value={formData.observacoes}
              onChange={handleChange}
              rows={4}
              maxLength={500}
              className="w-full px-4 py-3 bg-[#2A2F2A] border border-[#A2AEAB]/30 text-white placeholder-[#A2AEAB] focus:border-[#C0C0C0] focus:outline-none transition-colors text-sm resize-vertical"
              placeholder="Exemplo: Preciso de filmagem aérea para lançamento de empreendimento residencial. Local: Bairro Água Verde. Prazo: até 15 dias. Orçamento estimado: R$ 3.000. Gostaria de incluir imagens do entorno e fachada completa do prédio."
            />
            <div className="text-right text-xs text-[#A2AEAB] mt-1">
              {formData.observacoes.length}/500 caracteres
            </div>
          </div>

          <div className="text-center">
            <button
              type="submit"
              disabled={isSubmitting}
              className="bg-[#C0C0C0] text-[#2A2F2A] px-8 py-4 text-lg font-semibold hover:bg-white transition-colors duration-300 disabled:opacity-50 disabled:cursor-not-allowed whitespace-nowrap cursor-pointer rounded-full"
            >
              {isSubmitting ? 'Enviando...' : 'Enviar Orçamento'}
            </button>
          </div>

          {submitStatus === 'success' && (
            <div className="text-center p-4 bg-green-900/20 border border-green-500/30 text-green-400">
              Orçamento enviado com sucesso! Entraremos em contato em breve.
            </div>
          )}

          {submitStatus === 'error' && (
            <div className="text-center p-4 bg-red-900/20 border border-red-500/30 text-red-400">
              Erro ao enviar orçamento. Tente novamente ou entre em contato via WhatsApp.
            </div>
          )}
        </form>
      </div>
    </section>
  );
};

export default QuoteForm;
